import React from 'react'
import styled, { css } from 'styled-components'

export interface InlineBetaBadgeProps {
  text?: string
  isActive?: boolean
  isMobile?: boolean
  dataTestId?: string
  className?: string
  style?: React.CSSProperties
}

const getMobileColor = (isActive?: boolean) => (isActive ? '#B1E9C3' : '#898881')
const getDesktopBackground = (isActive?: boolean) => (isActive ? '#EEEDFE' : '#4A3373')
const getDesktopColor = (isActive?: boolean) => (isActive ? '#3C3489' : '#ffffff')

const Badge = styled.span<{ $isActive?: boolean; $isMobile?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-inline-start: 6px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
  pointer-events: none;
  vertical-align: middle;

  ${({ $isMobile, $isActive }) => {
    if ($isMobile) {
      return css`
        padding: 0;
        border-radius: 0;
        background: transparent;
        color: ${getMobileColor($isActive)};
      `
    }

    return css`
      padding: 2px 8px;
      border-radius: 999px;
      background-color: ${getDesktopBackground($isActive)};
      color: ${getDesktopColor($isActive)};
    `
  }}
`

const InlineBetaBadge = ({ text = '', isActive = false, isMobile = false, dataTestId, className, style }: InlineBetaBadgeProps): React.ReactElement | null => {
  if (!text) return null

  return (
    <Badge $isActive={isActive} $isMobile={isMobile} className={className} style={style} data-testid={dataTestId}>
      {text}
    </Badge>
  )
}

export default InlineBetaBadge
